import { Component, OnInit } from '@angular/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ViolationModel } from 'app/shared/violation-interface';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-admin-violations',
  templateUrl: './admin-violations.component.html',
  styleUrls: ['./admin-violations.component.scss']
})

export class AdminViolationsComponent implements OnInit {
  datas: any[];
  userId = this.parseService.instance.User.current().id;
  timeSheetData = [];
  selectedDate: Date;
  sample = [];
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];
  statusSelectItem: SelectItem[];
  typeSelectItem: SelectItem[];
  violationsData: ViolationModel[];
  inTimeCount = 0;
  inCompletedHrsCount = 0;
  breakHrsCount = 0;
  resourceCount = 0;
  selectedRepotee = 'all';
  selectedStatus = 'all';
  todayDate = new Date();
  selectbydate = new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
  maxDate = new Date();
  profileId = '';
  selectedType = 'all';
   

  constructor(
    private _fuseSidebarService: FuseSidebarService,
    private parseService: ParseService,
    private getReportingToService: GetReportingToService,
    private storageConfiguration: StorageConfiguration
  ) {
     

  }

  ngOnInit() {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.statusSelectItem = [
      { label: 'All', value: 'all' },
      { label: 'Open', value: 'open' },
      { label: 'Resolved', value: 'resolved' },
      { label: 'Escalated', value: 'escalated' }
    ];
    this.typeSelectItem = [
      { label: 'All', value: 'all' },
      { label: 'In Time', value: 'In-Time' },
      { label: 'Incompleted Hours', value: 'Incompleted-Hours' },
      { label: 'Break Hours', value: 'Exceeded-Break-Hours' }
    ];
    this.getReportingTo();

    // this.getAdminViolations('');
    // this.getResourceCount('');

    this.getViolationsByDate(this.selectbydate, this.selectedRepotee, this.selectedStatus, this.selectedType);
  }


  getViolationsByDate(event, id, status, type) {

    this.getResourceCount(id);
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    let today = new Date(event);
    let startend = this.startenddatesGraph(today);
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    query.descending('updatedAt');
    if (status != 'all') {
      query.equalTo('status', status);
    }
    if (id != '' && id != null && id != 'all') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: id });
    }

    this.getAdminViolations(query, type);
  }

  dayafterGraph(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybeforeGraph(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddatesGraph(day) {
    let startdate = this.daybeforeGraph(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafterGraph(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToDD = res;
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  toggleSidebar(name): void {
    this._fuseSidebarService.getSidebar(name).toggleOpen();
  }

  getResourceCount(id) {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isActive', true);
    if (id != '' && id != null && id != 'all') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: id });
    }
    query.count().then(results => {
      this.resourceCount = results;
    });
  }

  getAdminViolations(query, type) {
    this.violationsData = [];
    let violateValue = [];
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.include('userProfileId.location');
    query.find().then(results => {
      let violations = [];
      results.forEach(element => {
        let violate: ViolationModel = new ViolationModel();
        let vDate = element.get('violatedDate');
        violate.violatedDate = new Date(vDate);
        violate.userProfileId = element.get('userProfileId');
        violate.violations = element.get('violations');
        violate.startTime = element.get('userProfileId').get('officialInfo').startTime;
        violate.status = element.get('status');
        violate.reportingTo = element.get('reportingTo');
        violate.resolvedBy = element.get('resolvedBy');
        violate.resolvedDate = element.get('resolvedDate');
        violate.objectId = element.id;
        violations.push(violate);
      });
      violateValue = violations;
      if (type != '' && type != 'all') {
        let arrayValue = [];
        // violations = violateValue.filter(a => a.violations.filter(s => s.type == type));
        violateValue.forEach(element => {
          element.violations.forEach(innerElement => {
            if (innerElement.type == type) {
              arrayValue.push(element);
            }
          });
        });
        violations = arrayValue;

      } else {
        violations = violations;
      }
      this.violationsData = violations;
      this.inTimeCount = 0;
      this.inCompletedHrsCount = 0;
      this.breakHrsCount = 0;
      violations.forEach(element => {
        element.violations.forEach(innerElement => {
          if (innerElement.type == 'In-Time') {
            this.inTimeCount += 1;
          }
          if (innerElement.type == 'Incompleted-Hours') {
            this.inCompletedHrsCount += 1;
          }
          if (innerElement.type == 'Exceeded-Break-Hours') {
            this.breakHrsCount += 1;
          }
        });

      });
    });
  }

  filterReset() {
    this.selectbydate = new Date();
    this.selectedRepotee = '';
    this.selectedStatus = 'open';
    this.getViolationsByDate(this.selectbydate, this.selectedRepotee, this.selectedStatus, '');
  }


}




export interface adminViolation {
  inTime: string;
  inCompletedHours: string;
  keyLogs: string;
  gitCommit: string;
  breakHours: string;
  isEscalated: boolean;
  isResolved: boolean;
  reason: string;

}




export interface SelectItem {
  label?: string;
  value: any;
  styleClass?: string;
  icon?: string;
  title?: string;
  disabled?: boolean;
}